import React from 'react';
import { Error } from 'components';

const PagePermission: React.FC = () => {
  return <Error type="Permission"/>;
}

export default PagePermission;